App.ClientTagsEditController = Em.Controller.extend
  session: Em.inject.service()
  notifier: Em.inject.service()

  env:     Em.inject.service('environment')
  clientTagsEnabled:   Em.computed.alias('env.features.enableClientTagAutoassign')

  needs: [ 'client-tags', 'clientTagsIndex' ]

  clientTagBinding: 'model'

  isLoading: false

  dishesPage            : null
  dishesPageCount       : 0
  currentDishes         : Em.A([])
  isLoadingMoreDishes   : false

  canLoadMoreDishes: (->
    @get('dishesPage') < @get('dishesPageCount')
  ).property('dishesPage', 'dishesPageCount')

  actions:
    cancel: ->
      clientTag = @get('clientTag')

      if clientTag.get('isDirty') or clientTag.get('isNew')
        return unless confirm Em.I18n.t 'client_tag_info.confirm.cancel'
        clientTag = @get('clientTag')
        clientTag.rollback()

      @send('goBackToClientTagsList')
      false

    saveClientTag: ->
      @set('isLoading', true)
      clientTag = @get('clientTag')
      wasNew = clientTag.get('isNew')

      statusText = Em.I18n.t "client_tag_info.notifier.status.#{if wasNew then 'new' else 'old'}"
      clientTag.save()
      .then =>
        @set('isLoading', false)
        @transitionToRoute('client-tags')
        clientTag.reload()
        @get('notifier').pushNotification
          type:     'success'
          title:    Em.I18n.t 'client_tag_info.notifier.title', text: statusText
          duration: 3000

      false

    deleteClientTag: ->
      @set('isLoading', true)
      return unless confirm Em.I18n.t 'client_tag_info.confirm.delete'
      clientTag = @get('clientTag')
      clientTag.destroyRecord()
      .then =>
        @set('isLoading', false)
        @transitionToRoute('client-tags')

      false

    queryCategories: (defer, query) ->
      organization = @get('organization')

      @store.find('category', search: query)
        .then(defer.resolve, defer.reject)

      false

    queryDishes: (defer, query) ->
      @set('isLoadingMoreDishes', true)
      @store.find('dish', search: query)
        .then((dishes) =>
          # Установить данные в currentDishes
          @set('dishesPageCount', dishes.meta.page_count)
          @set('dishesPage', dishes.meta.page)
          @set('currentDishes', dishes)
          @set('isLoadingMoreDishes', false)
          # Затем выполнить defer.resolve с currentDishes
          defer.resolve(@get('currentDishes'))
        , defer.reject)

      false

    loadMoreDishes: (query) ->
      if @get('canLoadMoreDishes') and not @get('isLoadingMoreDishes')
        @incrementProperty('dishesPage')
        @set('isLoadingMoreDishes', true)
        @store.find('dish', _.merge({page: @get('dishesPage'), search: query}))
          .then (dishes) =>
            @set('isLoadingMoreDishes', false)
            @get('currentDishes').pushObjects(dishes.toArray())
      false

    queryTags: (defer, query) ->
      organization = @get('organization')

      @store.find('client_tag', search: query)
        .then(defer.resolve, defer.reject)

      false